{
  "dismiss": "Hylkää"
}
